/* Shadeday — ajout au panier depuis les sections sd-*, branché sur Horizon et sur le tiroir maison (sd-cart-drawer).
   window.SD.addToCart([{ id: variantId, quantity: n }, ...], sourceElement?) → Promise<cart>
   Reprend product-form.js d'Horizon : on émet un CartLinesUpdateEvent (bulle du header…), POST /cart/add.js avec les
   sections de chaque <cart-items-component>, puis on résout la promesse de l'événement.
   Les lignes d'une même variante sont fusionnées (une teinte = une ligne, quantité cumulée). */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

const SD = (window.SD = window.SD || {});
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

function cartSectionIds() {
  return [...document.querySelectorAll('cart-items-component')]
    .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
    .filter(Boolean);
}

/* Regroupe par variante (sans propriétés) : 3 bouteilles « Black, Black, Dark Brown » → 2 lignes. */
function mergeLines(items) {
  const out = [];
  const byId = new Map();
  for (const it of items || []) {
    if (!it || !it.id || !(Number(it.quantity) > 0)) continue;
    const plain = !it.properties && !it.selling_plan;
    const key = String(it.id);
    if (plain && byId.has(key)) {
      byId.get(key).quantity += Number(it.quantity);
      continue;
    }
    const line = { ...it, id: Number(it.id), quantity: Number(it.quantity) };
    out.push(line);
    if (plain) byId.set(key, line);
  }
  return out;
}

SD.addToCart = async function addToCart(items, source) {
  const lines = mergeLines(items);
  if (!lines.length) throw new Error('Nothing to add');
  const target = source instanceof Element && source.isConnected ? source : document.body;
  const sections = cartSectionIds();
  const deferred = CartLinesUpdateEvent.createPromise();
  const itemCount = lines.reduce((n, l) => n + l.quantity, 0);

  target.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity })),
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: lines.map((l) => ({ id: l.id, quantity: l.quantity, properties: l.properties || undefined, selling_plan: l.selling_plan || undefined })),
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await res.json();
    const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
    if (data.status || !res.ok) {
      target.dispatchEvent(new CartErrorEvent({ error: data.message || 'Add to cart failed', code: 'INVALID', detail: { description: data.description } }));
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'sd', itemCount } });
      const err = new Error(data.description || data.message || 'Add to cart failed');
      err.sdUserMessage = data.description || data.message;
      throw err;
    }
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { didError: false, items: cart.items, source: 'sd', itemCount, sections: data.sections || undefined },
    });
    document.dispatchEvent(new CustomEvent('sd:cart:added', { detail: { items: lines, cart } }));
    return cart;
  } catch (error) {
    try { deferred.reject(error); } catch (_) { /* déjà résolue */ }
    throw error;
  }
};

document.dispatchEvent(new CustomEvent('sd:cart:ready'));
